export default __webpack_public_path__ + "static/media/placeholder_private01-it-web.737bfa1b.png";